module.exports = __webpack_public_path__ + "img/img_target_right_bf.bb045955.svg";